import { render } from "./App.vue?vue&type=template&id=4505a0da"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4505a0da&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_11e9467a4b781779ddb796d6dfeeb8af/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__